import PaymentRequestsTransactionsModal from './index.vue'
export default PaymentRequestsTransactionsModal